import axios from 'axios';

/**
 * Centralized axios instance
 * Dev:  requests go to http://localhost:5000 (via CRA proxy)
 * Prod: requests go to https://backend.theunexploredroutes.com
 */
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 15000,
  withCredentials: false,
});

// Attach JWT token to every request automatically
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Don't redirect — let components handle it
    }
    return Promise.reject(error);
  }
);

export default API;
